<template>
  <div class="adv">
    <!-- 轮播图 -->
    <div class="banner">
      <div class="img">
        <img src="@/assets/imgs/collection.jpg" alt="" class="image" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 导航 -->
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">

          <el-breadcrumb-item :to="{ path: '/appreciate' }"
            >馆藏鉴赏</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="art">
      <div class="art-box">
        <div class="art-tit"></div>
        <div class="art-cont">
          <div
            class="art-a pos"
            v-for="inf in informationData"
            :alt="inf.title"
            :key="inf.museumCollectionClassifyId"
            @click="watchDetail(inf)"
            :style="{ backgroundImage: 'url(\'' + inf.bgImg + '\')' }"
          >
            <div class="small">{{ inf.collectionName }}</div>
          </div>
        </div>
      </div>
      <div class="nav-bottom">
        <!-- <el-pagination
            layout="prev, pager, next"
            :total="50">
          </el-pagination> -->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          layout=" prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// 展品列表
import axios from "axios";
export default {
  data() {
    return {
      path: "",
      id: "",
      name: "",
      infoData: [],
      informationData: [],
      total: 10,
      searchParams: {
        pageNum: 1,
        pageSize: 12,
      },
    };
  },
  created() {
    // this.id = decodeURIComponent(this.getQueryVariable('id'));
    // console.log(this.id);
    this.id = window.location.hash;
    console.log(window.location.hash, "window.location.hash");
    this.id = this.id.split("?")[1];
    console.log(this.id, "11111");
    let arr = this.id.split("&");
    console.log(arr, "arr");
    let s0 = arr[0].split("=");
    console.log(s0, "s0");
    this.id = s0[1];
    let s1 = arr[1].split("=");
    this.name = decodeURIComponent(s1[1]);
    this.path =
      "/appreciate/collectionList?id=" + this.id + "&name=" + this.name;
    this.getList().then((res) => {
      this.getImgList(res);
    });
  },

  mounted() {},
  methods: {
    handleCurrentChange(index) {
      console.log(index);
      this.searchParams.pageNum = index;
      this.getList().then((res) => {
        this.getImgList(res);
      });
    },
    getQueryVariable(key) {
      var url = window.location.hash;
      console.log(url, "this is url");
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
      // 匹配目标参数
      var result = url.substr(1).match(reg);
      //返回参数值
      return result ? decodeURIComponent(result[2]) : null;
    },
    async getList() {
      let res = await this.$axios.get(
        "/frontapi/museumCollection/exhibition/listByCategoryId/" + this.id,
        {
          params: {
            pageNum: this.searchParams.pageNum,
            pageSize: this.searchParams.pageSize,
          },
        }
      );
      this.informationData = res.data.rows;
      this.total = res.data.total;
      return this.informationData;
    },
    async getAttachment(id) {
      var info = await this.$axios({
        method: "get",
        url: "/common/fileInfo/" + id,
        data: {},
      });
      return info.data.data[0].filePath;
    },
    getImgList(arr) {
      for (let i = 0; i < arr.length; i++) {
        let bgImg = arr[i].params.reallyFilePath;
        let id = "";
        if (bgImg.indexOf(",") != -1) {
          console.log(11111111111111);
          let s = bgImg.split(",");
          bgImg = axios.defaults.baseURL + s[0];
        } else {
          bgImg = axios.defaults.baseURL + bgImg;
        }
        this.$set(arr[i], "bgImg", bgImg);
        // let obj = {};
        // this.getAttachment(id).then((data)=>{
        //    let bgImg = axios.defaults.baseURL + data;
        //    this.$set(arr[i],'bgImg',bgImg);
        // });
      }
      console.log(arr, "this is arr");
    },
    watchDetail(selObj) {
      console.log(selObj);
      console.log(selObj.id);
      console.log(selObj.categoryName, "haha");
      this.$router.push({
        path: "/appreciate/detail",
        query: { id: selObj.id, pname: selObj.categoryName, pid: this.id },
      });
    },
  },
};
</script>
<style scoped>
img {
  font-size: 18px;
}
.nav >>> .el-breadcrumb__inner.is-link {
  font-weight: 500;
  text-decoration: none;
  color: #606266;
}
/* *{margin: 0;padding: 0;} */
i {
  font-style: normal;
}
.adv {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
}
.banner {
  width: 100%;
  height: auto;
}
.banner .img {
  width: 100%;
  height: auto;
}
.image {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  padding-top: 60px;
}
.nav {
  font-size: 18px;
  width: 1199px;
  height: 18px;
  margin: 0 auto 40px;
}
.about >>> .nav {
  cursor: pointer;
}
.about >>> .is-link {
  font-weight: 400;
  color: #606266;
  /* cursor: text; */
}
.nav >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.art {
  width: 100%;
  height: 1200px;
  /* background: pink; */
}
.art-box {
  width: 1200px;
  height: 1086px;
  margin: 0 auto;
  background: #fff;
  padding-top: 29px;
  border-radius: 10px;
  overflow: auto;
}
.art-tit {
  width: 100%;
  height: 30px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  text-align: center;
  margin-bottom: 30px;
}
.art-cont {
  height: 1026px;
  /* padding-left: 28px; */
  padding-left: 12px;
  width: 1200px;
  /* background: pink; */
  margin: 0 auto;
}
.art-one {
  height: 302px;
  width: 100%;
  /* background: pink; */
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.art-a {
  width: 285px;
  height: 320px;
  /* margin-right: 28px; */
  border-radius: 10px;
  margin-right: 11px;
  margin-bottom: 15px;
  background-image: url("../../assets/imgs/tupian.png");
  background-size: 100% 100%;
  position: relative;
  cursor: pointer;
  float: left;
}
.small {
  width: 285px;
  height: 40px;
  border-radius: 0 0 10px 10px;
  background: #b78c0d;
  position: absolute;
  bottom: 0;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
}
.nav-bottom {
  width: 100%;
  display: flex;
  justify-content: center;
  /* margin-left: 609px; */
  margin-top: 31px;
}
::v-deep .nav-bottom .el-pagination .el-pager .number.active {
  color: #fff;
  background-color: #b78c0d;
}
/* ::v-deep .nav-bottom .el-pagination {
    color: #999999;
} */
::v-deep .nav-bottom .el-pagination button:hover {
  color: #b78c0d;
}
::v-deep .nav-bottom .el-pager li:hover {
  color: #b78c0d;
}
::v-deep .nav-bottom .el-pager li {
  margin-right: 2px;
}
::v-deep .nav-bottom .btn-prev {
  margin-right: 2px;
}
</style>
